module.exports = __webpack_public_path__ + "static/media/play-undo.66a28f5c.png";